import React from 'react';
import { PropertyOperation } from 'src/api/generated';
import Modal from 'src/modules/shared/components/molecules/modals/modal';
import { Text } from 'src/modules/shared/components/atoms/text';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import type { SupportedMeliOperation } from '../../utils/meli-publication.util';

interface PropertyMeliPublishingModalProps {
  isOpen: boolean;
  onClose: () => void;
  operation: SupportedMeliOperation;
  body: React.ReactNode;
  headerStatus?: React.ReactNode;
}

/**
 * Modal wrapper for the Mercado Libre publication manager.
 */
export const PropertyMeliPublishingModal: React.FC<
  PropertyMeliPublishingModalProps
> = ({ isOpen, onClose, operation, body, headerStatus }) => {
  const { t } = useI18n();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      dialogClassName="sm:max-w-4xl"
      header={
        <div className="flex items-start justify-between gap-4 pr-6">
          <div>
            <Text size="h6" weight="semibold" className="text-slate-900">
              {t('catalog.properties.meli.modal.title')}
            </Text>
            <div className="mt-1 flex flex-wrap items-center gap-2 text-slate-500">
              <Text size="small">
                {t('catalog.properties.editor.publishing.target.meli')}
              </Text>
              <span aria-hidden="true">·</span>
              <Text size="small">
                {t(
                  operation === PropertyOperation.SALE
                    ? 'catalog.properties.operation.SALE'
                    : 'catalog.properties.operation.RENT'
                )}
              </Text>
            </div>
          </div>
          {headerStatus ? (
            <div className="flex shrink-0 flex-wrap gap-2">{headerStatus}</div>
          ) : null}
        </div>
      }
      body={<div className="w-full px-4 py-4 sm:px-6 sm:py-5">{body}</div>}
    />
  );
};
